import Alert from "@/components/core/alert";
import { Blanket, BlanketImage, BlanketInfo } from "@/components/core/blanket.tsx";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/core/tabs.tsx";
import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import UserProfileDetailsForm from "@/features/dashboard/components/profile-details-form";
import UserProfilePasswordForm from "@/features/dashboard/components/profile-password-form";
import UserProfilePrivilegeForm from "@/features/dashboard/components/profile-privilege-form";
import type { PasswordFormSchema, ProfileFormSchema } from "@/features/dashboard/types/user";
import { useAuth } from "@/hooks/use-auth";
import { IconAlertCircle, IconMoodLookDown } from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";
import { AxiosError } from "axios";
import { useState } from "react";
import { toast } from "sonner";

export const Route = createFileRoute("/_dashboard/settings")({
	component: Page,
});

function Page() {
	const [success, setSuccess] = useState(false);
	const { updateProfile, user } = useAuth();
	const handleSubmit = async (data: ProfileFormSchema) => {
		try {
			await updateProfile(data);
			setSuccess(true);
		} catch (error) {
			toast.error("Failed to update profile.");
		}
	};
	const { changePassword } = useAuth();
	const handlePasswordSubmit = async (data: PasswordFormSchema, reset: () => void) => {
		try {
			await changePassword(data);
			setSuccess(true);
			reset();
		} catch (error) {
			if (error instanceof AxiosError && error.response) {
				toast.error(error.message);
			}
		}
	};

	return (
		<Content pageName="Profile">
			{/*<Header title="Profile" />*/}
			<div className="flex flex-col w-full max-w-base p-6 gap-6">
				<div className="flex flex-col w-full gap-4">
					<Tabs defaultValue="account" orientation="vertical">
						<TabsList>
							<TabsTrigger value="account">Account</TabsTrigger>
							<TabsTrigger value="privilege">Privilege</TabsTrigger>
							{/* <TabsTrigger value="security">Security</TabsTrigger> */}
							<TabsTrigger value="sessions">Sessions</TabsTrigger>
						</TabsList>
						<TabsContent value="account">
							{success && (
								<Alert className="mb-4" type="success" allowClose={true} title="Update Profile" icon={<IconAlertCircle size={20} stroke={2} />}>
									Profile has been successfully updated
								</Alert>
							)}
							<UserProfileDetailsForm data={user} onSubmit={handleSubmit} />
						</TabsContent>
						<TabsContent value="privilege">
							{success && (
								<Alert type="success" allowClose={true} title="Update Profile" icon={<IconAlertCircle size={20} stroke={2} />}>
									Profile has been successfully updated
								</Alert>
							)}
							<UserProfilePrivilegeForm data={user} onSubmit={handleSubmit} />
						</TabsContent>
						{/* <TabsContent value="security">
              {success && (
                <Alert type="success" allowClose={true} title="Update Profile" icon={<IconAlertCircle size={20} stroke={2} />}>
                  Profile has been successfully updated
                </Alert>
              )}
              <UserProfilePasswordForm data={user} onSubmit={handlePasswordSubmit} />
            </TabsContent> */}
						<TabsContent value="sessions">
							<Blanket width="sm">
								<BlanketImage icon={<IconMoodLookDown size={30} stroke={1.5} />} />
								<BlanketInfo title="No Data" message="No available data for for now. Please check back later or refresh the page." />
							</Blanket>
						</TabsContent>
					</Tabs>
				</div>
			</div>
		</Content>
	);
}
